import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

const modalStyle = {
  width: '500px',
  height: '300px',
  marginLeft: '-10%'
}

const propTypes = {
  selectedSalesOrder: PropTypes.object
}

const defaultProps = {
  selectedSalesOrder: {},
}

const testNoteComponent = ({
  input: {
    onChange, value
  }
}) => (
  <textarea
    onChange={onChange}
    value={value}
    style={{
      width: '100%',
      height: '78%',
      border: '1px solid black'
    }}
  />
)

const Notes = ({ setModalVisibility, isVisible }) => (
  <SkyLightStateless
    title={'Edit Notes'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <Field name="Notes" component={testNoteComponent} />
  </SkyLightStateless>
)

Notes.propTypes = propTypes
Notes.defaultProps = defaultProps

export default Notes;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/Notes.jsx